module.exports = {"name":"Central Park","description":"Central Park is a 17 acre park located in Old 4th Ward. It features a number of athletic and multi-purpose fields/courts and a playground. ","parking":"Street Parking is available alongside the park on Linden Ave and Pine St.","hours":"6am - 11pm","location":"https://www.google.com/maps/place/Central+Park/@33.768733,-84.3784072,17z","moreInfo":"http://www.centralparkatlanta.org/","tags":["playground","sports"],"images":["central1","central2","central3"]}


//////////////////
// WEBPACK FOOTER
// ./src/data/central-park.json
// module id = ./src/data/central-park.json
// module chunks = main